/* (Readonly) Source of truth for the PageGrid. Convenient if we need this in other components  */
export const gridData = {
  columns: {
    initial: 9,
    md: 12,
  },
  gaps: {
    initial: 2,
    md: 3,
    lg: 4,
    xl: 6,
  },
  gutters: {
    initial: 6,
    md: 10,
    xl: 24,
  },
  maxWidth: {
    initial: '100vw',
    xl: '1440px',
  },
} as const;
